import { SelectionVariant } from '../types/selectionVariant';
import VarType from 'Js/enums/varType';
export function useDropdownFilterButtonComposable() {
    function getDisplayName(originalValue, variant, items) {
        // display string is based on select strategy. For multiple ones we cannot simply show values, but just a number of the values
        const value = originalValue;
        if (variant === SelectionVariant.Single)
            return items.find((item) => item.Id === value)?.Name ?? items[0]?.Name ?? items[0];
        // When no value, show "All"
        if (value == undefined || (Array.isArray(value) && value.length === 0))
            return items[0]?.Name ?? items[0];
        // For non-array, simply get value from the array
        if (!Array.isArray(value))
            return items[value];
        // When only one option is selected, get a Name
        if (value?.length === 1) {
            const option = items.find(i => (i?.Id ?? i) === value[0]);
            return option ? optionTitle(option) : '';
        }
        // For multiple selected values show only number of selected values to not overflow the UI
        if (value?.length > 0 && value.length < items.length - 1)
            return value.length;
        else
            return items[0]?.Name ?? items[0];
    }
    function isString(value) {
        return typeof value === VarType.String || value instanceof String;
    }
    function optionTitle(option) {
        if (isString(option))
            return option;
        return option.Name;
    }
    function selectItem(items, variant, index, modelValue, menuIsVisible = undefined) {
        const option = items[index];
        const value = (typeof (option) == VarType.Object) ? option.Id : option;
        let newSelection = Array.isArray(modelValue) ? [...modelValue] : modelValue === 0 ? [] : [modelValue];
        if (newSelection[0] === undefined) {
            newSelection = [];
        }
        const optionIndex = newSelection.indexOf(value);
        if (variant === SelectionVariant.Multiple) {
            if (optionIndex > -1) {
                newSelection.splice(optionIndex, 1);
            }
            else {
                newSelection.push(value);
            }
            if (option?.Id === undefined) {
                newSelection = [];
                if (menuIsVisible) {
                    menuIsVisible.value = false;
                }
            }
        }
        else {
            newSelection = value;
            menuIsVisible.value = false;
        }
        return newSelection;
    }
    return {
        getDisplayName,
        optionTitle,
        selectItem,
    };
}
